import { combineLatest } from 'rxjs';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import {
  AdvisorData,
  BrandingService,
  CompanyBrandingHelper,
  IdentityVerificationMethod,
  SsoAccountData,
  SsoAccountFacade,
  SessionStorageKey,
  SessionStorageState,
} from 'common';
import { VerifyIdentityFacade } from './verify-identity.facade';
import { EntityFacade } from '../../../entity/domain/+state/entity.facade';

@UntilDestroy()
@Component({
    selector: 'ifm-verify-identity',
    templateUrl: './verify-identity.component.html',
    styleUrls: ['./verify-identity.component.scss'],
    providers: [VerifyIdentityFacade],
    standalone: false
})
export class VerifyIdentityComponent implements OnInit {
  currentMethod: IdentityVerificationMethod;
  advisorData: AdvisorData;
  readonly IdentityVerificationMethod = IdentityVerificationMethod;

  constructor(
    private readonly ssoAccountFacade: SsoAccountFacade,
    private readonly facade: VerifyIdentityFacade,
    private readonly entityFacade: EntityFacade,
    private readonly brandingService: BrandingService,
  ) {
    SessionStorageState.set(SessionStorageKey.AccountSetupViewed, true);
  }

  ngOnInit(): void {
    this.initData();
  }

  private initData(): void {
    combineLatest([
      this.entityFacade.getEntity$(null),
      this.brandingService.getBranding$(),
      this.ssoAccountFacade.getSsoAccountCheckoutState$()
    ]).pipe(untilDestroyed(this)).subscribe(([entity, branding, checkoutState]) => {
      this.advisorData = {
        fullName: entity?.advisorName,
        email: entity?.advisorEmail,
        phone: CompanyBrandingHelper.getAdvisorPhone(branding, entity?.advisorPhone)
      };
      this.currentMethod = checkoutState?.method;
    });
  }

  onVerified(currentAccont: SsoAccountData): void {
    this.facade.handleVerifyIdentitySuccessRedirect(currentAccont);
  }

  onIdVerseFailedNoRetry(isExpired: boolean): void {
    this.facade.handleIdVerseFailedRedirect(isExpired);
  }
}
